import { Navigate } from "react-router-dom";

/**
 * 2x Leveraged listing landing page — redirects to the unified products
 * catalog with the Leveraged filter pre-applied (mirrors the dane
 * `leveraged-products/page.tsx`). Wire at route path `/2xleveraged`.
 */
export function LeveragedProductsPage() {
  return <Navigate to="/products?category=leveraged" replace />;
}
